/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowRoundaboutRight = createReactComponent(
  "arrow-roundabout-right",
  "IconArrowRoundaboutRight",
  [
    ["path", { d: "M21 9h-8a5 5 0 1 0 -5 5v7", key: "svg-0" }],
    ["path", { d: "M17 5l4 4l-4 4", key: "svg-1" }]
  ]
);

export { IconArrowRoundaboutRight as default };
//# sourceMappingURL=IconArrowRoundaboutRight.js.map
